import {
    patchState,
    signalStore,
    withComputed,
    withHooks,
    withMethods,
    withState,
} from "@ngrx/signals";
import {
    setError,
    setFulfilled,
    setPending,
    withRequestStatus,
} from "../extensions/request-status.feature";
import { computed, inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { filter, pipe, switchMap, tap } from "rxjs";
import { withRouteParams } from "../extensions/route-params.feature";
import { ApiQuestsService } from "../../services/api-quests.service";
import { setEntity } from "@ngrx/signals/entities";
import { QuestsStore } from "./quests.store";

export type QuestStore = InstanceType<typeof QuestStore>;

export const QuestStore = signalStore(
    { protectedState: false },
    withState<{ questId: number }>({
        questId: 0,
    }),
    withRouteParams({ questId: (param) => Number(param) }),
    withRequestStatus(),
    withComputed(({ questId }, questsStore = inject(QuestsStore)) => ({
        quest: computed(() => (questId() ? questsStore.entityMap()[questId()] : null)),
    })),
    withMethods(
        (
            store,
            questsStore = inject(QuestsStore),
            apiQuestsService = inject(ApiQuestsService),
        ) => ({
            loadQuest: rxMethod<number>(
                pipe(
                    filter((id) => !!id && !store.quest()),
                    tap(() => patchState(store, setPending())),
                    switchMap((id) => {
                        return apiQuestsService.getQuest(id).pipe(
                            tap({
                                next: (quest) => {
                                    patchState(store, setFulfilled());
                                    patchState(questsStore, setEntity(quest));
                                },
                                error: (error) => patchState(store, setError(error.error.error)),
                            }),
                        );
                    }),
                ),
            ),
        }),
    ),
    withHooks({
        onInit({ loadQuest, questId }) {
            loadQuest(questId);
        },
    }),
);
